import { PostRequest, GetRequest } from '@/util/http';

export function APIImportLogs() {
  return PostRequest(`data/import/logs`, {});
} // APIFetchExpectations
